import React, { useState } from "react";

import PropTypes from "prop-types";

import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import LayersIcon from "@mui/icons-material/Layers";
import MapIcon from "@mui/icons-material/Map";
import CircleIcon from "@mui/icons-material/Circle";

import FiltersCheckboxes from "./FiltersCheckboxes";
import CheckboxListWithParent from "../common/CheckboxListWithParent";
import SingleCheckbox from "../common/SingleCheckbox";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GiglLongDescription, giglShortDescription } from "../copy/GiglCopy";
import { SudsLongDescription, sudsShortDescription } from "../copy/SudsCopy";
import {
  CatchmentLongDescription,
  catchmentShortDescription,
} from "../copy/CatchmentCopy";
import {
  ThamesCombinedLongDescription,
  thamesCombinedShortDescription,
} from "../copy/ThamesCombinedCopy";
import {
  ThamesSeperateLongDescription,
  thamesSeperateShortDescription,
} from "../copy/ThamesSeperateCopy";
import { waterShortDescription } from "../copy/WaterCopy";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const DrawerContent = ({
  setSitesProperties,
  sitesProperties,
  filtersProperties,
  setFiltersProperties,
  noFilters,
  setNoFilters,
  catchmentPartnershipProperties,
  setCatchmentPartnershipProperties,
  giglOpenSpaceProperties,
  setGiglOpenSpaceProperties,
  thamesCombinedProperties,
  setThamesCombinedProperties,
  thamesSeperateProperties,
  setThamesSeperateProperties,
  watercoursesProperties,
  setWatercoursesProperties,
  boroughProperties,
  setBoroughProperties,
  mapProperties,
  setMapProperties,
  catchmentOpacityOffset,
  setCatchmentOpacityOffset,
  giglOpacityOffset,
  setGiglOpacityOffset,
  thamesCombinedOpacityOffset,
  setThamesCombinedOpacityOffset,
  thamesSeparateOpacityOffset,
  setThamesSeparateOpacityOffset,
  watercoursesOpacityOffset,
  setWatercoursesOpacityOffset,
}) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        pl: 3,
        pr: 3,
        maxHeight: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        zIndex: 100,
      }}
    >
      <Box sx={{ maxHeight: "80px", height: "80px" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="map-tabs"
          selectionFollowsFocus
          variant="fullWidth"
        >
          <Tab
            icon={<CircleIcon />}
            disableRipple
            label={"SuDS Sites"}
            aria-label="filter"
          />
          <Tab
            icon={<LayersIcon />}
            disableRipple
            label={"Map Layers"}
            aria-label="layers"
          />

          <Tab
            icon={<MapIcon />}
            disableRipple
            label={"Base Maps"}
            aria-label="base"
          />
        </Tabs>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          height: "100%",
          maxHeight: "100%",
          mb: isMobile ? 2 : 6,
        }}
      >
        <TabPanel value={value} index={0}>
          <CheckboxListWithParent
            parentCheckboxLabel="SuDS Sites"
            setChecked={setSitesProperties}
            checked={sitesProperties}
            shortDescription={sudsShortDescription}
            longDescription={<SudsLongDescription />}
          />
          <FiltersCheckboxes
            setCheckedFilters={setFiltersProperties}
            checkedFilters={filtersProperties}
            noFilters={noFilters}
            setNoFilters={setNoFilters}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CheckboxListWithParent
            checked={catchmentPartnershipProperties}
            setChecked={setCatchmentPartnershipProperties}
            parentCheckboxLabel="Catchment Partnerships"
            initialCollapseOpen={false}
            shortDescription={catchmentShortDescription}
            longDescription={<CatchmentLongDescription />}
            offset={catchmentOpacityOffset}
            setOffset={setCatchmentOpacityOffset}
          />
          <SingleCheckbox
            checked={giglOpenSpaceProperties}
            setChecked={setGiglOpenSpaceProperties}
            offset={giglOpacityOffset}
            setOffset={setGiglOpacityOffset}
            shortDescription={giglShortDescription}
            longDescription={<GiglLongDescription />}
          />
          <SingleCheckbox
            checked={thamesCombinedProperties}
            setChecked={setThamesCombinedProperties}
            offset={thamesCombinedOpacityOffset}
            setOffset={setThamesCombinedOpacityOffset}
            shortDescription={thamesCombinedShortDescription}
            longDescription={<ThamesCombinedLongDescription />}
          />
          <SingleCheckbox
            checked={thamesSeperateProperties}
            setChecked={setThamesSeperateProperties}
            offset={thamesSeparateOpacityOffset}
            setOffset={setThamesSeparateOpacityOffset}
            shortDescription={thamesSeperateShortDescription}
            longDescription={<ThamesSeperateLongDescription />}
          />
          <SingleCheckbox
            checked={watercoursesProperties}
            setChecked={setWatercoursesProperties}
            offset={watercoursesOpacityOffset}
            setOffset={setWatercoursesOpacityOffset}
            shortDescription={waterShortDescription}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <SingleCheckbox
            checked={boroughProperties}
            setChecked={setBoroughProperties}
          />
          <SingleCheckbox
            checked={mapProperties}
            setChecked={setMapProperties}
          />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default DrawerContent;
